
import React from 'react';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      {/* Left Arch (Abstract Eye/Steam) */}
      <path 
        d="M7 8C7 8 8.5 5 10 8" 
        stroke="currentColor" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      
      {/* Right Arch (Abstract Eye/Steam) */}
      <path 
        d="M14 8C14 8 15.5 5 17 8" 
        stroke="currentColor" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      
      {/* Middle Curve (Smile/Rim) */}
      <path 
        d="M7 13C7 13 12 17 17 13" 
        stroke="currentColor" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      
      {/* Bottom Swoosh (Chin/Cup Body) */}
      <path 
        d="M5 18C5 18 12 23 19 15" 
        stroke="currentColor" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
